import React, { useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TransportationTable19 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  // Extract years dynamically
  const years = Object.keys(data[0]).filter((k) => !isNaN(k));

  // Generate datasets
  const chartData = {
    labels: years,
    datasets: data.map((record, idx) => ({
      label: record.race_label,
      data: years.map((year) => parseInt(record[year] || 0)),
      borderColor: `hsl(${(idx * 60) % 360}, 70%, 50%)`,
      backgroundColor: `hsl(${(idx * 60) % 360}, 70%, 80%)`,
      fill: false,
      tension: 0.3,
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Employment by Race (2018–2024)",
      },
    },
    scales: {
      x: { title: { display: true, text: "Year" } },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Employment Count" },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    const originalWidth = input.style.width;
    input.style.width = "1200px";

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdfDoc = new jsPDF("l", "mm", "a4"); // landscape

      const imgWidth = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdfDoc.addImage(utahData, "PNG", 20, 10, 32, 16);
      pdfDoc.setFontSize(20);
      pdfDoc.text("UTahData.org", 60, 20);
      pdfDoc.link(20, 10, 60, 10, { url: "https://utahdata.org" });
      pdfDoc.line(10, 30, 287, 30);

      // Main chart & table
      const headerHeight = 35;
      pdfDoc.addImage(
        imgData,
        "PNG",
        10,
        headerHeight,
        imgWidth - 20,
        imgHeight
      );

      // Footer
      pdfDoc.line(10, 190, 287, 190);
      const footerY = 195;
      pdfDoc.addImage(utahData, "PNG", 22, footerY, 30, 15);
      pdfDoc.setFontSize(10);
      pdfDoc.text("Built by", 60, footerY + 10);
      pdfDoc.addImage(bodex, "PNG", 75, footerY + 4, 44, 10);
      pdfDoc.text("using", 125, footerY + 10);
      pdfDoc.addImage(kpi, "PNG", 140, footerY, 20, 20);
      pdfDoc.text(" 20250916.v3.198", 165, footerY + 10);

      const currentDate = new Date().toLocaleDateString();
      pdfDoc.text(`Downloaded on: ${currentDate}`, 200, 210);
      pdfDoc.text(`Downloaded from: ${window.location.href}`, 10, 210);

      pdfDoc.save("race-employment-trend.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <>
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Employment by Race (2018-2024)</h2>
          <div className="overflow-x-auto">
            <table className="table table-striped bg-white">
              <thead>
                <tr>
                  <th>Race</th>
                  {years.map((year, idx) => (
                    <th key={idx}>{year}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((record, rIdx) => (
                  <tr key={rIdx}>
                    <td>{record.race_label}</td>
                    {years.map((year, idx) => (
                      <td key={idx}>{record[year]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Chart */}
        <div
          style={{
            width: "95%",
            maxWidth: "950px",
            margin: "auto",
            background: "#fff",
          }}
        >
          <Line data={chartData} options={options} />
        </div>
      </div>

      {/* Download Button */}
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} alt="pdf-icon" />
          </span>
        </button>
      </div>
    </>
  );
};

export default TransportationTable19;
